import React from "react";

type State = "asc" | "desc" | "none";

type Props = { state: State; className?: string };

/**
 * Stacked-chevron sort indicator. Always visible on sortable headers so
 * users know the column can be sorted; the active direction lights up.
 */
export default function SortIndicator({ state, className = "" }: Props) {
  const upActive = state === "asc";
  const downActive = state === "desc";
  const dim = "text-ink-3/45";
  const active = "text-ink";
  return (
    <span
      aria-hidden
      className={`inline-flex flex-col justify-center leading-none ml-1.5 ${className}`}
      style={{ fontSize: 8, transform: "translateY(-1px)" }}
    >
      <span className={upActive ? active : dim}>▲</span>
      <span
        className={downActive ? active : dim}
        style={{ marginTop: 1 }}
      >
        ▼
      </span>
    </span>
  );
}
